import { render, staticRenderFns } from "./configOptionalRole.vue?vue&type=template&id=c29fdfbc&scoped=true"
import script from "./configOptionalRole.vue?vue&type=script&lang=js"
export * from "./configOptionalRole.vue?vue&type=script&lang=js"
import style0 from "./configOptionalRole.vue?vue&type=style&index=0&id=c29fdfbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c29fdfbc",
  null
  
)

export default component.exports